import React, { useEffect, useState } from "react";
import Image from "next/image";
import axios from "axios";
import { useForm } from "react-hook-form";
import { reviewApi } from "../../../utils/apiRoute";
import { Rating } from "@material-tailwind/react";
import toast from "react-hot-toast";
import { useRouter } from "next/router";
import { getLocals } from "../../../getLocal";
import { hostNameFunction } from "../../../utils/host-function";

export default function ReviewForm({ apiData }) {
  const [localizedStrings, setLocalizedStrings] = useState();

  useEffect(() => {
    const fetchLocalizedStrings = async () => {
      const lang = hostNameFunction() || "en";
      const strings = await getLocals(lang);
      setLocalizedStrings(strings);
    };

    fetchLocalizedStrings();
  }, []);
  const route = useRouter();
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [inputValue, setInputValue] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [rating, setRating] = useState(0);
  const [captchaError, setCaptchaError] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const handleBlur = (e) => {
    let value = e.target.value;
    // Remove non-numeric characters
    value = value.replace(/\D/g, "");
    // Ensure the length is exactly 10 digits
    if (value.length > 10) {
      value = value.substring(0, 10);
    }
    setValue("phoneNumber", value, { shouldValidate: true });
  };

  const handleChange = (e) => {
    let value = e.target.value;
    // Remove non-numeric characters
    value = value.replace(/\D/g, "");
    // Ensure the length is exactly 10 digits
    if (value.length > 10) {
      value = value.substring(0, 10);
    }
    setValue("phoneNumber", value);
  };

  const handleFullNameBlur = (e) => {
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z\s]/g, ""); // Remove non-alphabetic characters
    setValue("name", value, { shouldValidate: true });
  };

  const handleFullNameChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z\s]/g, ""); // Remove non-alphabetic characters
    setValue("name", value);
  };

  const onSubmit = async (data) => {
    const updatedData = {
      ...data,
      review_rating: rating,
      businessName: apiData.name,
      businessSlug: apiData.slug,
      businessId: apiData.id,
    };
    if (rating == 0) {
      alert("please select a rating");
      return;
    }
    if (!isValid) {
      setCaptchaError("Fill Captcha");
      return;
    }
    try {
      const response = await axios.post(reviewApi, updatedData);
      if (response.data.status == "success") {
        toast.success(
          "Your review has been submitted successfully. Once approved by  admin, it will be live on the website."
        );
        reset();
        setInputValue("");
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        toast.error("Something went wrong! Please try Again");
        route.push("/");
      }
      console.log("Form submitted successfully!", response.data);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  function generateCaptcha() {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let result = "";
    for (let i = 0; i < 4; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  }

  function handleInputChange(event) {
    const value = event.target.value;
    setInputValue(value);
    if (value === captcha) {
      setIsValid(true);
      setCaptchaError("");
    } else {
      setIsValid(false);
      setCaptchaError(value.length === 0 ? "" : "Wrong Captcha");
    }
  }

  const handleRatingChange = (newRating) => {
    setRating(newRating);
  };

  const generateNewCaptcha = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const length = 4; // Set the length of the captcha code
    let newCaptcha = "";
    for (let i = 0; i < length; i++) {
      newCaptcha += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return newCaptcha;
  };

  const refreshCaptcha = () => {
    const newCaptcha = generateNewCaptcha();
    setCaptcha(newCaptcha);
    setInputValue("");
    setIsValid(false);
    setCaptchaError("");
  };

  return (
    <>
      <div>
        <div className="flex items-center gap-2">
          <div>
            <Image
              src="/assets/img/write.svg"
              className="md:w-8 md:h-8 w-6"
              width={8}
              height={8}
              alt="image"
            />
          </div>
          <div>
            <p className="text-base">
              <b>
                {localizedStrings && localizedStrings.Index.BusinessPage.Review}{" "}
                {""}
                {apiData.name}
              </b>
            </p>
          </div>
        </div>

        <div className="flex pb-4">
          <div className="pt-3 w-[300px] h-[250px]"></div>

          <form
            className="md:max-w-sm w-full mx-auto mt-5"
            id="form1"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="pl-10">
              <Rating
                unratedColor="amber"
                ratedColor="amber"
                className="gap-8 "
                value={rating}
                onChange={handleRatingChange}
              />
            </div>
            <div className="mb-5 flex flex-col pt-2">
              <input
                type="text"
                id="name"
                name="name"
                {...register("name", {
                  required: "Your Name is required",
                  pattern: {
                    value: /^[A-Za-z\s]+$/,
                    message:
                      "Please enter a valid name (letters and spaces only)",
                  },
                })}
                className="border border-gray-300 text-gray-900 md:text-sm text-lg focus:ring-blue-500
          focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600
          dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder={
                  localizedStrings && localizedStrings.Index.BusinessPage.Name
                }
                onBlur={handleFullNameBlur}
                onChange={handleFullNameChange}
              />
              {errors.name && (
                <span className="text-red-500">{errors.name.message}</span>
              )}
            </div>
            <div className="mb-5 flex flex-col">
              <input
                type="email"
                id="email"
                name="email"
                className=" border border-gray-300 text-gray-900 md:text-sm text-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 "
                placeholder={
                  localizedStrings && localizedStrings.Index.BusinessPage.Email
                }
                {...register("email", { required: true })}
              />
              {errors.email && (
                <span className="text-red-500">Email is required</span>
              )}
            </div>
            <div className="mb-5 flex flex-col">
              <input
                type="text"
                id="number"
                name="phoneNumber"
                {...register("phoneNumber", {
                  required: "Phone number is required",
                  validate: {
                    isNumber: (value) =>
                      /^\d+$/.test(value) ||
                      "Text and special characters are not allowed",
                    isValidLength: (value) =>
                      value.length === 10 ||
                      "Phone number must be exactly 10 digits",
                  },
                })}
                onBlur={handleBlur}
                onChange={handleChange}
                className="border border-gray-300 text-gray-900 md:text-sm text-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder={
                  localizedStrings && localizedStrings.Index.BusinessPage.Mobile
                }
              />
              {errors.phoneNumber && (
                <span className="text-red-500">
                  {errors.phoneNumber.message}
                </span>
              )}
            </div>

            <textarea
              id="review"
              name="review"
              rows="4"
              className="p-2.5 w-full md:text-sm text-lg text-gray-900 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder={
                localizedStrings &&
                localizedStrings.Index.BusinessPage.ReviewMessage
              }
              {...register("review_comment", {
                required: "Your Review is must",
                pattern: {
                  value: /^[A-Za-z\s]+$/,
                  message:
                    "Please enter a valid review (letters and spaces only)",
                },
              })}
            ></textarea>
            {errors.review_comment && (
              <span className="text-red-500">
                {errors.review_comment.message}
              </span>
            )}

            <div className="flex pb-2">
              <div className="text-lg font-bold border border-gray-300 px-3 py-2 inline-block mr-4">
                {captcha}
              </div>
              <input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                className="border px-3 py-2 rounded-md mr-4"
                placeholder={
                  localizedStrings &&
                  localizedStrings.Index.BusinessPage.Captcha
                }
              />
              {captchaError && (
                <span className="text-red-500">{captchaError}</span>
              )}
              <button
                type="button"
                className="flex items-center px-4 py-2 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-indigo-600 rounded-lg hover:bg-indigo-500 focus:outline-none focus:ring focus:ring-indigo-300 focus:ring-opacity-80"
                onClick={refreshCaptcha}
              >
                <svg
                  className="w-5 h-5 mx-1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>

            <button
              type="submit"
              className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full  px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              {localizedStrings && localizedStrings.Index.BusinessPage.Submit}
            </button>
          </form>

          <div className="pt-3 w-[300px] h-[250px]"></div>
        </div>
      </div>
    </>
  );
}
